module.exports = __webpack_public_path__ + "img/compliance-logo-black.45a03b3c.svg";